import {
  roboqlFields,
  roboqlMetadataComparators,
} from "@/shared/components/RoboqlEditor/roboqlFields";
import { QueryTarget } from "@/shared/domain/query";
import { Comparator, isComparator } from "@/types";

export type SearchFieldType = "date" | "metadata" | "tags" | "other";

export type MetadataType = "string" | "number" | "boolean";

export interface SearchField {
  name: string;
  type: SearchFieldType;
}

export function comparatorForSearchField(
  searchField: SearchField,
  queryTarget: QueryTarget,
  metadataType: MetadataType,
): Comparator[] {
  const field = roboqlFields[queryTarget].find((field) => {
    return field.label === searchField.name;
  });

  if (!field || !field.comparators) {
    return [];
  }

  let comparators: Comparator[] = field.comparators.filter(isComparator);

  // special metadata case. return only those comparators that match the metadata type
  if (searchField.type === "metadata") {
    if (metadataType === "string") {
      comparators = comparators.filter((comparator) => {
        return roboqlMetadataComparators.string_metadata.includes(comparator);
      });
    }
    if (metadataType === "number") {
      comparators = comparators.filter((comparator) => {
        return roboqlMetadataComparators.numeric_metadata.includes(comparator);
      });
    }
    if (metadataType === "boolean") {
      comparators = comparators.filter((comparator) => {
        return roboqlMetadataComparators.boolean_metadata.includes(comparator);
      });
    }
  }

  return comparators.sort((a, b) => a.localeCompare(b));
}
